/* EcomChief buy box — itemized summary, live total on the button, package and
   design price labels, and (phones/tablets) an inline design preview with a
   full-screen swipe gallery. Reads the state kept by ec-v2-product.js
   (<ecx-product>) and the variant data Liquid prints. Never changes cart data
   or order details itself: choosing a design in the gallery clicks the real
   design radio, so ec-v2-product.js stays the single source of truth. */
(function () {
  'use strict';
  var fmt = function (cents) {
    if (window.ECX && typeof window.ECX.money === 'function') return window.ECX.money(cents);
    var n = cents / 100;
    return '$' + (n % 1 ? n.toFixed(2) : String(n));
  };
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  /* Optional analytics: Shopify customer events (readable from a custom pixel) and dataLayer */
  var track = function (name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  };
  var mobile = function () { return window.matchMedia ? window.matchMedia('(max-width: 1023px)').matches : window.innerWidth < 1024; };

  function init(el) {
    if (el.__ecxBB) return;
    el.__ecxBB = true;
    var form = q('form[data-ecx-form]', el);
    if (!form) return;
    var vj = q('[data-ecx-variants]', el), variants = [];
    try { variants = vj ? JSON.parse(vj.textContent) : []; } catch (e) { variants = []; }
    if (!variants.length) return;

    var sum = q('[data-bb-summary]', el), lines = q('[data-bb-lines]', el);
    var baseLabel = sum ? sum.getAttribute('data-base-label') : '';
    var emailLabel = sum ? sum.getAttribute('data-email-label') : '';
    var looks = q('[data-looks]', el);
    var dIdx = looks ? +looks.getAttribute('data-opt-group') : -1;
    var stdIn = looks ? q('input[data-std]', looks) : null;
    var groups = qa('[data-bb-group]', el).map(function (g) {
      return { el: g, i: +g.getAttribute('data-bb-group'), first: g.getAttribute('data-bb-first') };
    });
    var email = q('[data-email-addon]', el);
    var cta = q('button[data-add]', form);
    var idIn = q('input[name="id"]', form);
    var product = (el.getAttribute('data-niche') || '');

    function find(o) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k], ok = true;
        for (var j = 0; j < o.length; j++) { if (v.o[j] !== o[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function current() {
      if (el.state && el.state.options) return el.state.options.slice();
      var id = idIn ? String(idIn.value) : '';
      var v = variants.filter(function (x) { return String(x.id) === id; })[0] || variants[0];
      return v.o.slice();
    }
    /* the same selection with the included design */
    function withStd(o) {
      var b = o.slice();
      if (dIdx >= 0 && stdIn) b[dIdx] = stdIn.value;
      return b;
    }

    function render() {
      var o = current(), v = find(o);
      var dIn = looks ? q('input:checked', looks) : null;

      if (looks && dIn) renderDesign(dIn);
      if (!v) return;

      /* summary: the chosen package at its full price, then the design and email on top */
      var out = [], pkg = find(withStd(o)) || v, suffix = '';
      groups.forEach(function (g) {
        var inp = q('input[data-opt-input]:checked', g.el);
        if (inp && o[g.i] !== g.first) suffix += inp.getAttribute('data-bb-sum') || (' · ' + inp.value);
      });
      out.push({ l: baseLabel + suffix, v: fmt(pkg.p) });
      if (dIdx >= 0) {
        var dd = v.p - pkg.p;
        out.push({ l: 'Design: ' + (dIn ? (dIn.dataset.name || dIn.value) : o[dIdx]), v: dd > 0 ? '+' + fmt(dd) : 'Included', inc: dd <= 0 });
      }
      var add = email && email.checked ? (+email.dataset.emailPrice || 0) : 0;
      if (add) out.push({ l: emailLabel, v: '+' + fmt(add) });
      if (lines) {
        lines.innerHTML = out.map(function (x) {
          return '<div class="ecx-bb-line"><span>' + esc(x.l) + '</span><span class="ecx-bb-v' + (x.inc ? ' is-inc' : '') + '">' + esc(x.v) + '</span></div>';
        }).join('');
      }

      /* package cards: each package's full price with the included design */
      groups.forEach(function (g) {
        qa('input[data-opt-input]', g.el).forEach(function (inp) {
          var row = inp.closest('.ecx-pkg'), lab = row ? q('[data-bb-delta]', row) : null;
          if (!lab) return;
          var a = withStd(o); a[g.i] = inp.value;
          var alt = find(a);
          lab.textContent = alt ? fmt(alt.p) : '';
        });
      });

      /* the main button carries the live total */
      if (cta && !cta.disabled) {
        cta.innerHTML = esc(cta.dataset.addLabel) + '<span class="ecx-bb-sep" aria-hidden="true">·</span><span class="ecx-bb-amt">' + esc(fmt(v.p + add)) + '</span>';
      }
      save();
    }

    /* ---------- remember the selection across a visit to a full design page ----------
       Design pages link back with "Just the store + that design". The buyer's own
       package and email choice are remembered here and put back on return. */
    var KEY = 'ecx-bb:' + (location.pathname.split('/').filter(Boolean).pop() || ''), restoring = false;
    function save() {
      if (restoring) return;
      try {
        var s = { t: Date.now(), groups: {}, email: !!(email && email.checked), design: null };
        groups.forEach(function (g) { var i = q('input[data-opt-input]:checked', g.el); if (i) s.groups[g.i] = i.value; });
        var d = looks ? q('input:checked', looks) : null;
        if (d) s.design = d.value;
        localStorage.setItem(KEY, JSON.stringify(s));
      } catch (e) {}
    }
    function returnFromDesign() {
      var params = new URLSearchParams(location.search), from = params.get('ecx_from');
      if (!from && /\/pages\/[^?#]*premium-design/i.test(document.referrer || '')) from = 'pick';
      if (from !== 'pick' && from !== 'back') return;
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
      if (saved && Date.now() - (saved.t || 0) > 3 * 3600 * 1000) saved = null;
      restoring = true;
      if (saved) {
        groups.forEach(function (g) {
          var val = saved.groups && saved.groups[g.i];
          if (val == null) return;
          var inp = qa('input[data-opt-input]', g.el).filter(function (x) { return x.value === val; })[0];
          if (inp && !inp.checked) inp.click();
        });
        if (from === 'back' && saved.design && looks) {
          var di = qa('input[data-opt-input]', looks).filter(function (x) { return x.value === saved.design; })[0];
          if (di && !di.checked) di.click();
        }
        if (email && saved.email && !email.checked) { email.checked = true; email.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      restoring = false;
      render();
      /* tidy the address bar, keep ?variant= */
      try { params.delete('ecx_from'); var u = location.pathname + (params.toString() ? '?' + params.toString() : ''); history.replaceState(history.state, '', u); } catch (e) {}
      /* land on the buy box, not the top of the page */
      var target = looks || q('[data-bb-group]', el) || form, moved = false;
      var land = function () {
        if (moved) return;
        var hdr = parseFloat(getComputedStyle(el).getPropertyValue('--hdr')) || 72;
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - hdr - 16), behavior: 'auto' });
      };
      ['touchstart', 'wheel', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { moved = true; }, { once: true, passive: true }); });
      requestAnimationFrame(land);
      if (document.readyState !== 'complete') window.addEventListener('load', land, { once: true });
      var d = looks ? q('input:checked', looks) : null, card = d ? d.closest('.ecx-look') : null, price = card ? q('[data-look-delta]', card) : null;
      var msg = from === 'pick' && d
        ? '<b>' + esc(d.dataset.name || d.value) + ' selected</b>' + (price && /\d/.test(price.textContent) ? ' · ' + esc(price.textContent.trim()) : '') + (saved ? '<span>Your package and add-ons are kept.</span>' : '')
        : '<b>Welcome back</b><span>Your selection is just as you left it.</span>';
      toast(msg);
      track('ecx_design_return', { product: product, from: from, design: d ? (d.dataset.name || d.value) : '' });
    }
    function toast(html) {
      var t = document.createElement('div');
      t.className = 'ecx ecx-bb-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#10B981"/><path d="M6 10.4l2.6 2.5L14 7.4" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><p>' + html + '</p>';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-on'); });
      setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 4500);
    }

    /* selected design: detail line, and on phones a large inline preview of premium designs */
    var mprev = looks ? q('[data-bb-mprev]', looks) : null;
    function renderDesign(dIn) {
      var dn = q('[data-bb-dname]', looks), dd = q('[data-bb-ddesc]', looks), dl = q('[data-bb-dlink]', looks);
      if (dn) dn.textContent = dIn.dataset.name || dIn.dataset.label || dIn.value;
      if (dd) dd.textContent = dIn.dataset.desc ? '· ' + dIn.dataset.desc : '';
      if (dl) { dl.hidden = !dIn.dataset.url; if (dIn.dataset.url) dl.href = dIn.dataset.url; }
      if (!mprev) return;
      var prem = !dIn.hasAttribute('data-std') && !!dIn.dataset.img;
      mprev.hidden = !prem;
      if (!prem) return;
      var img = q('[data-bb-mprev-img]', mprev), go = q('[data-bb-mprev-link]', mprev);
      if (img && img.getAttribute('src') !== dIn.dataset.img) img.src = dIn.dataset.img;
      if (img) img.alt = (dIn.dataset.name || dIn.value) + ' store design preview';
      if (go) { go.hidden = !dIn.dataset.url; if (dIn.dataset.url) go.href = dIn.dataset.url; }
    }

    /* ---------- full-screen swipe gallery ---------- */
    var gal = null, galIdx = 0, lastFocus = null, galSlides = [];
    function designs() {
      return looks ? qa('input[data-opt-input]', looks).map(function (inp) {
        var card = inp.closest('.ecx-look'), thumb = card ? q('.ecx-look__shot img', card) : null, price = card ? q('[data-look-delta]', card) : null;
        return {
          input: inp,
          name: inp.dataset.name || inp.value,
          desc: inp.dataset.desc || '',
          img: inp.dataset.img || (thumb ? thumb.currentSrc || thumb.src : ''),
          url: inp.dataset.url || '',
          price: price ? price.textContent.trim() : '',
          std: inp.hasAttribute('data-std')
        };
      }) : [];
    }
    function buildGallery() {
      gal = document.createElement('div');
      /* lives on <body> so no sticky or transformed ancestor can trap the fixed overlay */
      gal.className = 'ecx ecx-bb-gal';
      gal.setAttribute('role', 'dialog');
      gal.setAttribute('aria-modal', 'true');
      gal.setAttribute('aria-label', 'Store designs');
      gal.hidden = true;
      gal.innerHTML =
        '<div class="ecx-bb-gal__top">' +
          '<div class="ecx-bb-gal__t"><b data-gal-n></b><span data-gal-s></span></div>' +
          '<span class="ecx-bb-gal__c" data-gal-c aria-live="polite"></span>' +
          '<button type="button" class="ecx-bb-gal__x" data-gal-x aria-label="Close designs">' +
            '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ecx-bb-gal__track" data-gal-track tabindex="0"></div>' +
        '<div class="ecx-bb-gal__dots" data-gal-dots aria-hidden="true"></div>' +
        '<div class="ecx-bb-gal__bar">' +
          '<a class="ecx-bb-gal__live" data-gal-live href="#" target="_blank" rel="noopener">Open the full design ↗<span class="ecx-vh"> (opens in a new tab)</span></a>' +
          '<button type="button" class="ecx-btn ecx-btn--go ecx-btn--block ecx-bb-gal__use" data-gal-use></button>' +
        '</div>';
      document.body.appendChild(gal);
      var track = q('[data-gal-track]', gal), to;
      track.addEventListener('scroll', function () {
        clearTimeout(to);
        to = setTimeout(function () { setGal(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), false); }, 60);
      }, { passive: true });
      q('[data-gal-x]', gal).addEventListener('click', closeGallery);
      q('[data-gal-use]', gal).addEventListener('click', function () {
        var d = galSlides[galIdx];
        if (d && !d.input.checked) d.input.click();
        track_('ecx_design_gallery_use', d);
        closeGallery();
      });
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeGallery(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); setGal(galIdx + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); setGal(galIdx - 1, true); }
        else if (e.key === 'Tab') {
          var f = qa('button, a[href]', gal).filter(function (x) { return !x.hidden && x.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
    }
    function track_(name, d) { if (d) track(name, { product: product, design: d.name, premium: !d.std }); }
    function setGal(i, scroll) {
      if (!galSlides.length) return;
      i = Math.max(0, Math.min(galSlides.length - 1, i));
      galIdx = i;
      var d = galSlides[i], track = q('[data-gal-track]', gal);
      if (scroll) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      q('[data-gal-n]', gal).textContent = d.name;
      q('[data-gal-s]', gal).textContent = d.desc;
      q('[data-gal-c]', gal).textContent = (i + 1) + ' / ' + galSlides.length;
      qa('[data-gal-dots] i', gal).forEach(function (dot, j) { dot.classList.toggle('is-on', j === i); });
      var live = q('[data-gal-live]', gal);
      live.hidden = !d.url;
      if (d.url) live.href = d.url;
      var use = q('[data-gal-use]', gal);
      if (d.input.checked) use.textContent = d.std ? 'Keep the included design' : 'Keep ' + d.name;
      else use.textContent = d.std ? 'Use the included design' : 'Use ' + d.name + (d.price ? ' · ' + d.price : '');
    }
    function openGallery() {
      if (!looks) return;
      if (!gal) buildGallery();
      galSlides = designs();
      var track = q('[data-gal-track]', gal), dots = q('[data-gal-dots]', gal);
      track.innerHTML = galSlides.map(function (d, i) {
        return '<figure class="ecx-bb-gal__slide">' +
          (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.name) + ' store design" loading="' + (i ? 'lazy' : 'eager') + '" decoding="async">' : '') +
          '<figcaption class="ecx-vh">' + esc(d.name) + (d.desc ? ', ' + esc(d.desc) : '') + '</figcaption>' +
        '</figure>';
      }).join('');
      dots.innerHTML = galSlides.map(function () { return '<i></i>'; }).join('');
      var start = 0;
      galSlides.forEach(function (d, i) { if (d.input.checked) start = i; });
      lastFocus = document.activeElement;
      gal.hidden = false;
      document.documentElement.classList.add('ecx-bb-gal-open');
      requestAnimationFrame(function () {
        track.scrollLeft = track.clientWidth * start;
        setGal(start, false);
        q('[data-gal-x]', gal).focus();
      });
      track_('ecx_design_gallery_open', galSlides[start]);
    }
    function closeGallery() {
      if (!gal || gal.hidden) return;
      gal.hidden = true;
      document.documentElement.classList.remove('ecx-bb-gal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }
    if (looks) {
      var opener = q('[data-bb-gallery-open]', looks);
      if (opener) opener.addEventListener('click', openGallery);
      qa('input[data-opt-input]', looks).forEach(function (inp) {
        inp.addEventListener('change', function () {
          if (!inp.checked) return;
          track(inp.hasAttribute('data-std') ? 'ecx_design_select_standard' : 'ecx_design_select_premium',
            { product: product, design: inp.dataset.name || inp.value, mobile: mobile() });
        });
      });
    }

    el.addEventListener('ecx:variant', render);
    if (email) email.addEventListener('change', function () { setTimeout(render, 0); });

    /* the email address follows the brand typed in the address bar */
    var brand = q('[data-brand]', el), addr = q('[data-bb-email-addr]', el);
    if (brand && addr) {
      var orig = addr.textContent;
      brand.addEventListener('input', function () {
        var slug = brand.value.toLowerCase().replace(/\.com$/, '').replace(/[^a-z0-9-]+/g, '');
        addr.textContent = slug ? 'hello@' + slug + '.com' : orig;
      });
    }
    /* arriving from a design page: don't overwrite the remembered selection before it is restored */
    restoring = /[?&]ecx_from=(pick|back)/.test(location.search) || /\/pages\/[^?#]*premium-design/i.test(document.referrer || '');
    render();
    /* restore once ec-v2-product.js is running, so clicks update the real variant */
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('ecx-product').then(function () { setTimeout(returnFromDesign, 0); });
    else restoring = false;
  }

  function boot() { qa('ecx-product').forEach(init); }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('ecx-product').then(boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
